export default (el) => ({
  id: String(el.id),
  status: el.status || '',
  virtual: Boolean(el.virtual),
  eventId: String(el.event_id),
  seatId: String(el.hall_scheme_seat_id),
  price: Number(el.price),
  created: el.date_created ? new Date(el.date_created) : null,
  payed: el.date_payed ? new Date(el.date_payed) : null,
  refunded: el.date_refunded ? new Date(el.date_refunded) : null,
  cancelled: el.date_cancelled ? new Date(el.date_cancelled) : null,
});
